import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustryDigitalPayments'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
